var _excluded = ["options", "children", "size", "valueRightElement", "emptyState", "creatableOption", "isDisabled", "isReadOnly", "isViewMode", "isLoading", "value", "placeholder", "onInputChange", "onChange", "formatSelectedValue", "onClick", "onKeyDown", "onFocus", "onBlur", "onSearchTermReset", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { isEqual } from 'lodash';
import { forwardRef } from '../../../utils';
import { BaseSelect, useSelect } from '../../internal/BaseSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export var Select = forwardRef((_ref, ref) => {
  var {
    options,
    children,
    size = 'large',
    valueRightElement,
    emptyState,
    creatableOption,
    isDisabled = false,
    isReadOnly = false,
    isViewMode = false,
    isLoading = false,
    value,
    placeholder,
    onInputChange,
    onChange,
    formatSelectedValue,
    onClick,
    onKeyDown,
    onFocus,
    onBlur,
    onSearchTermReset,
    id
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var filterOptions = (options, searchTerm) => searchTerm ? options.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase())) : options;

  var {
    isOpen,
    hasSections,
    getToggleButtonProps,
    inputValue,
    inputProps,
    dropdownMenuProps,
    getOptionProps,
    selectedOption,
    filteredOptions
  } = useSelect({
    ref,
    value,
    formatSelectedValue,
    options,
    filterOptions,
    creatableOption,
    emptyState,
    disableInputClick: isDisabled || isLoading || isReadOnly,
    onClick,
    onChange,
    onInputChange,
    onKeyDown,
    onSearchTermReset
  });

  var creatableOptionComponent = typeof creatableOption === 'object' && /*#__PURE__*/_jsx(BaseSelect.CreatableOption, _objectSpread({
    message: typeof creatableOption.label === 'string' ? creatableOption.label : creatableOption.label(inputValue)
  }, getOptionProps({
    option: {
      value: inputValue.toLocaleLowerCase(),
      label: inputValue
    },
    index: filteredOptions.length,
    isCreatableOption: true
  })));

  var sharedProps = {
    isDisabled,
    isViewMode,
    isReadOnly: isReadOnly || isLoading,
    isLoading
  };

  var rightElement = /*#__PURE__*/_jsx(BaseSelect.TriggerRightIcon, _objectSpread(_objectSpread({
    "data-testid": "select-toggle-button",
    "aria-label": "Toggle select dropdown menu",
    size: "small",
    icon: isOpen ? 'caret-up' : 'caret-down'
  }, sharedProps), !isDisabled && !isReadOnly && getToggleButtonProps()));

  return /*#__PURE__*/_jsx(BaseSelect, {
    "data-component": "Select",
    trigger: /*#__PURE__*/_jsx(BaseSelect.Input, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, inputProps), props), sharedProps), {}, {
      id: id,
      onFocus: onFocus,
      onBlur: onBlur,
      placeholder: placeholder,
      size: size,
      selectValue: value,
      selectedOption: selectedOption,
      hasSections: hasSections,
      valueRightElement: valueRightElement,
      rightElement: rightElement
    })),
    dropdownMenu: /*#__PURE__*/_jsx(BaseSelect.DropdownMenu, _objectSpread(_objectSpread({}, dropdownMenuProps), {}, {
      isLoading: isLoading,
      loadingStateComponent: /*#__PURE__*/_jsx(BaseSelect.LoadingState, {}),
      creatableOptionComponent: creatableOptionComponent,
      renderOption: (option, index) => /*#__PURE__*/_jsx(BaseSelect.Option, _objectSpread(_objectSpread({}, getOptionProps({
        option,
        index
      })), {}, {
        children: /*#__PURE__*/_jsx(BaseSelect.OptionContent, _objectSpread(_objectSpread({}, option), {}, {
          isSelected: isEqual(option.value, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)
        }))
      }))
    }))
  });
});
Select.displayName = 'Select';
//# sourceMappingURL=Select.js.map